import EventsClient from '../../client/EventsClient';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
//Note: This does not require auth because it is assumed that the ImClient will already redirect if there is an issue with the cookie
let sessionKey = cookies.get('kjd_session');
let client = new EventsClient({sessionKey: sessionKey});

export default client;